/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.DateUtils.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.Calendar.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.I18n.d.ts" />

import * as React from "react";
import calendarStore from "../../stores/calendarStore";
import {IEndDateStatus} from "../../stores/calendarStore";
import appstate from "../../appstate";

export interface IDatepickerWidgetProps {
    isStartDate: boolean,
    availabilityCalendar: CC.Library.Models.Calendar.CalendarResponse,
    selectedDate: Date,
    setDateCallback: (newDate: Date, monthIndex?: number) => void,
    firstSelectableDate: Date,
    headline: string,
    toggleCallback: any,
    startMonthIndex: number,
    currentStartdate: Date,
    currentEndDate: Date
}

export interface IDatepickerWidgetState {
    selectedDate: string,
    monthIndex: number
}

export interface ICalendarMonth {
    days: JSX.Element[]
}

export class DatepickerWidget extends React.Component<IDatepickerWidgetProps, IDatepickerWidgetState> {

    private paginateIcon = <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="34.266px" height="71.329px" viewBox="0 0 34.266 71.329" enable-background="new 0 0 34.266 71.329" xmlSpace="preserve">
            <polyline fill="none" stroke-width="4px" stroke-miterlimit="10" points="8.946,7.684 26.99,35.19 8.925,62.73 "/>
        </svg>;

    constructor(props: IDatepickerWidgetProps) {
        super(props);

        this.props = props;

        this.handleClick = this.handleClick.bind(this);
        this.monthPagePrev = this.monthPagePrev.bind(this);
        this.monthPageNext = this.monthPageNext.bind(this);
        this.isEndDateAvailable = this.isEndDateAvailable.bind(this);

        this.state = {
            selectedDate: NCB.DateUtils.getISODate(this.props.selectedDate),
            monthIndex: props.startMonthIndex
        };
    }

    componentDidMount() {
        calendarStore.loadCallback = () => { this.forceUpdate(); };
    }

    componentWillUnmount() {
        calendarStore.loadCallback = null;
    }

    componentWillReceiveProps(nextProps: IDatepickerWidgetProps) {
        this.setState({
            selectedDate: NCB.DateUtils.getISODate(nextProps.selectedDate)
        });    
    }
    
    handleClick(e: any) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        let newDate = new Date(Date.parse(e.currentTarget.getAttribute("data-date")));

        this.props.setDateCallback(newDate, this.state.monthIndex);
    }

    monthPagePrev() {
        let newIndex = this.state.monthIndex - 1;
        if (newIndex < 0)
            newIndex = 0;

        this.setState({
            monthIndex: newIndex
        }, this.loadAvailability);
    }
    monthPageNext() {
        let newIndex = this.state.monthIndex + 1;

        this.setState({
            monthIndex: newIndex
        }, this.loadAvailability); 
    }

    loadAvailability = () => {
        //console.log("datepickerWidget.loadAvailability()");
        let currentMonthIndex = -1;
        let lastMonth: string = null;
        this.props.availabilityCalendar.Availability.forEach((x, i) => {
            let parsedMonth = x.Date.split('-')[1];
            if (lastMonth == null || lastMonth != parsedMonth) {
                currentMonthIndex++;
                lastMonth = parsedMonth;
                
                if (currentMonthIndex == this.state.monthIndex) {
                    //console.log("datepickerWidget.loadAvailability() --- currentMonthIndex", currentMonthIndex);
                    calendarStore.hintStartDate = new Date(Date.parse(calendarStore.calendarResponse.Availability[i].Date));
                    //console.log("datepickerWidget.loadAvailability() --- calendarStore.hintStartDate", calendarStore.hintStartDate);
                }
            } 
        });
    }

    isEndDateAvailable(checkEndDate: string): IEndDateStatus {
        return calendarStore.isEndDateAvailable(this.props.currentStartdate, new Date(Date.parse(checkEndDate)));
    }

    /* STYLE */
    private style: React.CSSProperties = {
        position: "absolute"
    }

    private dayStyle: React.CSSProperties = {
        float: "left",
        width: "14%"
    }
    private monthLabelStyle: React.CSSProperties = {
        clear: "both"
    }
    private weekdayLabelStyle: React.CSSProperties = {
        clear: "both"
    }

    private dayLabel = <div className="ncb-datepickerWidget-weekdays-label" style={this.weekdayLabelStyle}>
        <div className="ncb-datepickerWidget-weekdays-label-day" style={this.dayStyle}>{NCB.I18n.T.WEEKDAY_0.substr(0,2)}</div>
        <div className="ncb-datepickerWidget-weekdays-label-day" style={this.dayStyle}>{NCB.I18n.T.WEEKDAY_1.substr(0,2)}</div>
        <div className="ncb-datepickerWidget-weekdays-label-day" style={this.dayStyle}>{NCB.I18n.T.WEEKDAY_2.substr(0,2)}</div>
        <div className="ncb-datepickerWidget-weekdays-label-day" style={this.dayStyle}>{NCB.I18n.T.WEEKDAY_3.substr(0,2)}</div>
        <div className="ncb-datepickerWidget-weekdays-label-day" style={this.dayStyle}>{NCB.I18n.T.WEEKDAY_4.substr(0,2)}</div>
        <div className="ncb-datepickerWidget-weekdays-label-day" style={this.dayStyle}>{NCB.I18n.T.WEEKDAY_5.substr(0,2)}</div>
        <div className="ncb-datepickerWidget-weekdays-label-day" style={this.dayStyle}>{NCB.I18n.T.WEEKDAY_6.substr(0,2)}</div>
    </div>;

    render() {
        let cal = this.props.availabilityCalendar;

        if (cal == null)
            return;

        let monthCounter = 0;
        
        let days: JSX.Element[] = [];
        let months: ICalendarMonth[] = [];

        let firstDate = new Date(cal.Availability[0].Date);

        let firstDayIndex = NCB.DateUtils.getDay(firstDate);
        let parsedDate = new Date(Date.parse(cal.Availability[0].Date));
        let currentMonth = parsedDate.getUTCMonth();
        let currentYear = parsedDate.getUTCFullYear();

        days.push(<div className="ncb-datepickerWidget-month-label" style={this.monthLabelStyle}>{NCB.DateUtils.getMonthName(currentMonth)} {currentYear}</div>);

        // Does the first available month start on a day except monday? In that case, fill up with days from previous month
        if (firstDayIndex !== 0) {
            let prefillDays = firstDayIndex;

            days.push(this.dayLabel);

            while (prefillDays > 0) {
                prefillDays--;
                
                let tempDate = new Date(firstDate.getTime());
                tempDate.setUTCDate(prefillDays * -1);
            
                days.push(<div className="ncb-datepickerWidget-day" style={this.dayStyle}>{tempDate.getUTCDate()}</div>);   
            }
        } else {
            days.push(this.dayLabel);
        }
        
        // Iterate over the available dates from the calendar and build the HTML
        let isPassedToday = false;
        
        let startDateString = NCB.DateUtils.getISODate(this.props.currentStartdate);
        let prevDay: CC.Library.Models.Calendar.CalendarDay;
        let nightsSinceStartDay = -1;
        let selectedStartDay: CC.Library.Models.Calendar.CalendarDay =  null;

        // MAIN LOOP
        cal.Availability.forEach((x) => {

            if (nightsSinceStartDay > -1)
                nightsSinceStartDay++;

            // Find the start date object
            if (!this.props.isStartDate && x.Date === startDateString) {
                selectedStartDay = x;
                nightsSinceStartDay = 0;
            }

            // Only do the date comparison if the still have not passed today's date
            let parsedDate = new Date(Date.parse(x.Date));

            let classes: string[] = ["ncb-datepickerWidget-day", "ncb-datepickerWidget-day-status-" + x.Status.toString().toLowerCase()];

            if (isPassedToday === false) {
                if (parsedDate >= this.props.firstSelectableDate) {
                    classes.push("ncb-datepickerWidget-day-first-selectable");
                    isPassedToday = true;
                }
            } 
            
            // Add month divider?
            if (parsedDate.getUTCMonth() !== currentMonth) {
                currentMonth = parsedDate.getUTCMonth();

                months.push({days: days});
                days = [];

                days.push(<div className="ncb-datepickerWidget-month-label" style={this.monthLabelStyle}>{NCB.DateUtils.getMonthName(currentMonth)} {parsedDate.getUTCFullYear()}</div>);
                days.push(this.dayLabel);

                // Prefill the week with empty days to make it align with the week above
                for (let i=0; NCB.DateUtils.getDay(parsedDate) > i; i++) {
                    days.push(<div className="ncb-datepickerWidget-day-filler" style={this.dayStyle}>&nbsp;</div>);
                }
            }

            let clickHandler = null;

            if (isPassedToday) {
                let isSelectable = true;

                if (this.props.isStartDate) {
                    // Select startDate
                    if (x.Status === CC.Library.Models.Calendar.AvailabilityStatus.Closed || x.Status === CC.Library.Models.Calendar.AvailabilityStatus.ClosedOnArrival)
                        isSelectable = false;

                    if (x.Status === CC.Library.Models.Calendar.AvailabilityStatus.MaxStay)
                        classes.push("ncb-day-maxStay");

                    if (x.Status === CC.Library.Models.Calendar.AvailabilityStatus.MinStay)
                        classes.push("ncb-day-minStay");

                } else {
                    // Select enddate
                    let isEndDateAvailable = this.isEndDateAvailable(x.Date);

                    if (prevDay.Status === CC.Library.Models.Calendar.AvailabilityStatus.Closed || isEndDateAvailable !== IEndDateStatus.Available) {
                        isSelectable = false;
                    }
                    
                    if (isEndDateAvailable === IEndDateStatus.Loading) {
                        classes.push("ncb-availability-pending");
                    }
                }

                if (isSelectable || appstate.useAlternativeHotel) {
                    classes.push("selectable");
                    
                    clickHandler = this.handleClick;
    
                    if (this.state.selectedDate === x.Date)
                        classes.push("ncb-datepickerWidget-day-selected");
                }
            }

            // Handle MinStay/MaxStay
            if (!this.props.isStartDate && selectedStartDay != null) {
                 // MinStay
                 if (selectedStartDay.Status === CC.Library.Models.Calendar.AvailabilityStatus.MinStay) {
                    if (nightsSinceStartDay < parseInt(selectedStartDay.Quantity)) {
                        clickHandler = () => { alert(NCB.I18n.T.PRICE_CALENDAR_MIN_NIGHTS_REQUIRED.replace('%QTY%', selectedStartDay.Quantity)) };
                        classes = classes.filter((x) => { return x !== "selectable" });
                    }
                }

                // MaxStay
                if (selectedStartDay.Status === CC.Library.Models.Calendar.AvailabilityStatus.MaxStay) {
                    if (nightsSinceStartDay > parseInt(selectedStartDay.Quantity)) {
                        clickHandler = () => { alert(NCB.I18n.T.PRICE_CALENDAR_MAX_NIGHTS_AVAILABLE.replace('%QTY%', selectedStartDay.Quantity)) };
                        classes = classes.filter((x) => { return x !== "selectable" });
                    }
                }               
            }
                
            days.push(<div className={classes.join(" ")}  style={this.dayStyle} onClick={clickHandler} data-date={x.Date}>{parsedDate.getUTCDate()}</div>);

            prevDay = x;
        });

        months.push({days: days});

        days = (this.state.monthIndex > months.length - 1) ? months[months.length - 1].days : months[this.state.monthIndex].days;

        let nextButton = this.state.monthIndex > months.length - 1 ? null : <span className="ncb-datepickerWidget-month-paginator-next-icon" onClick={this.monthPageNext}>{this.paginateIcon}</span>;
        let prevButton = this.state.monthIndex === 0 ? null : <span className="ncb-datepickerWidget-month-paginator-prev-icon"  onClick={this.monthPagePrev}>{this.paginateIcon}</span>;

        return <div className="ncb-datepickerWidget" data-is-startDate={this.props.isStartDate} style={this.style} onClick={(e: any) => {e.stopPropagation()}}>
            <div className="ncb-datepickerWidget-inner">
                {days}
                <div className="ncb-datepickerWidget-month-paginator">
                    {prevButton}
                    {nextButton}
                </div>
            </div>
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/components/datepicker/datepickerWidget.tsx